<template>
  <div
    class="cn23-item-card"
    :class="{ 'shipping-costs-route-item--is-last': isLastItem }"
  >
    <b-row>
      <b-col cols="6" sm="6" md="4">
        <b-form-group
          :label="$t('Origin')"
          label-for="origin-country"
          class="shipping-costs-route-item__form-group"
        >
          <shipping-costs-select
            class="custom-input"
            :country="item.originCountry"
            topCountry="NL"
            :placeholder="$t('Select country')"
            :whiteList="['DE', 'NL', 'FR', 'ES', 'IT', 'GB', 'BE', 'AT']"
            countryName
            :usei18n="false"
            @input="
              ({ countryName, countryShortCode }) =>
                updateOriginCountry({
                  name: countryName,
                  shortcode: countryShortCode,
                })
            "
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" sm="6" md="4">
        <b-form-group
          :label="$t('Destination')"
          label-for="origin-country"
          class="shipping-costs-route-item__form-group"
        >
          <shipping-costs-select
            class="custom-input"
            :country="item.destinationCountry"
            :topCountry="item.originCountry || 'DE'"
            :placeholder="$t('Select country')"
            :whiteList="item.originCountryShortcode === 'GB' ? ['GB'] : null"
            countryName
            :usei18n="false"
            @input="
              ({ countryName, countryShortCode }) =>
                updateDestinationCountry({
                  name: countryName,
                  shortcode: countryShortCode,
                })
            "
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="12" md="4">
        <b-form-group
          :label="$t('Monthly volume')"
          label-for="volume"
          class="shipping-costs-route-item__form-group"
        >
          <b-form-input
            class="custom-input"
            id="volume"
            :value="item.volume"
            trim
            type="number"
            step="100"
            min="50"
            number
            @input="updateVolume"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <button
      class="delete-button"
      :aria-label="$t('Delete route')"
      v-if="index > 0"
      @click="deleteItem"
    >
      <font-awesome-icon icon="trash-alt" />
    </button>
    <button class="add-new-button" @click="$emit('add-item')" v-if="isLastItem">
      <font-awesome-icon icon="plus" />
      {{ $t("Add another route") }}
    </button>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput } from "bootstrap-vue";
import ShippingCostsSelect from "./ShippingCostsSelect";

export default {
  components: {
    ShippingCostsSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  props: ["index", "item", "isLastItem", "$v", "hasFormError"],
  methods: {
    updateOriginCountry({ name, shortcode }) {
      this.$emit("update-item", {
        volume: this.item.volume,
        originCountry: name,
        originCountryShortcode: shortcode,
        destinationCountry: this.item.destinationCountry,
        destinationCountryShortcode: this.item.destinationCountryShortcode,
      });
    },
    updateDestinationCountry({ name, shortcode }) {
      this.$emit("update-item", {
        volume: this.item.volume,
        originCountry: this.item.originCountry,
        originCountryShortcode: this.item.originCountryShortcode,
        destinationCountry: name,
        destinationCountryShortcode: shortcode,
      });
    },
    updateVolume(volume) {
      this.item.volume = parseInt(volume);
      this.$emit("update-item", {
        volume,
        originCountry: this.item.originCountry,
        originCountryShortcode: this.item.originCountryShortcode,
        destinationCountry: this.item.destinationCountry,
        destinationCountryShortcode: this.item.destinationCountryShortcode,
      });
    },
    deleteItem() {
      this.$emit("delete-item");
    },
  },
};
</script>

<style scoped>
.cn23-item-card {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0px 0px 40px 0px;
  background: rgb(251, 251, 251);
  border: 1px solid rgb(241, 241, 241);
  border-radius: 15px;
  line-height: 1em;
  padding: 25px;
}

.delete-button {
  right: -20px;
  top: -23px;
  position: absolute;
  width: 45px;
  min-height: 45px;
  margin: 0px;
  border: 1px solid #f1f1f1;
  color: #122857;
  border-radius: 34px;
  transition: background 0.25s ease-in-out;
  background: white;
  font-size: 18px;
  line-height: 1em;
}

.add-new-button {
  margin: 0px auto;
  margin-bottom: -45px;
  padding: 10px 15px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(231, 231, 231);
  border-radius: 45px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease-in-out, background 0.2s ease-in-out;
  font-weight: 600;
  font-size: 17px;
  line-height: 1em;
  color: #122857;
}

.add-new-button:focus {
  outline: none;
  background: rgba(0, 0, 0, 0.05);
}

.hs-code-button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #122857;
  border: inherit;
}

@media screen and (max-width: 576px) {
  .delete-button {
    right: 20px;
  }
}

.shipping-costs-route-item__form-group {
  margin-bottom: 0;
}

.shipping-costs-route-item--is-last .shipping-costs-route-item__form-group {
  margin-bottom: 20px;
}

>>> select.custom-input {
  width: 100%;
}
</style>
